<template>
  <PreOrderPaymentButton
    :isLoading="isLoading"
    :totalPaymentPrice="totalPaymentPrice"
    :certification="certification"
    :onPayment="doPayment"
    :onCertificate="redirectCertificationPage"
  />
</template>

<script>
import PreOrderPaymentButton from '../../layouts/organisms/PreOrderPaymentButton'
import {
  validateDeliveryDetailAddress,
  validatePhoneNumber,
  validateUserEmail
} from '../../../../../models/PreOrder/OrderRequest'
import { Location, Action, MoveType } from '../../../../../plugins/AppManager'
import API, { initApiUrl } from '@/store/api'
import { LogScreenName, LogType, LogGroup, LogEvent } from '@/plugins/AppLogManager'

export default {
  name: 'PreOrderPaymentButtonContainer',
  components: { PreOrderPaymentButton },
  data() {
    return {
      isLoading: false
    }
  },
  computed: {
    key() {
      return this.$store.getters['preOrder/orderSheetKey']
    },
    userEmail() {
      return this.$store.getters.userEmail
    },
    totalPaymentPrice() {
      return this.$store.getters['preOrder/totalPaymentPrice']
    },
    certification() {
      return this.$store.getters['preOrder/certification']
    },
    delivery() {
      return this.$store.getters['preOrder/delivery']
    },
    isSign() {
      return this.$store.getters['isSign']
    }
  },
  watch: {
    // TODO check src/components/order/OrderButton.vue:113
    async key(key) {
      if (key === null) return

      const { failed } = await this.$store.dispatch('preOrder/loadUserCertification')
      if (failed) {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message: '주문 중 문제가 발생했습니다. 잠시 후 다시 시도해주세요.',
          onOK: async () => {
            this.$appManager.action(Action.CLOSE)
          }
        })
      }
    }
  },
  methods: {
    doPaymentLog() {
      const params = {
        ShopNo: this.$store.getters['baeminShopNo']
      }

      // M2-1
      this.$appLogManager.post({
        screenName: LogScreenName.MARKET_ORD,
        type: LogType.CLICK,
        group: LogGroup.ORD,
        event: LogEvent.ORD,
        params
      })
    },

    async doPayment() {
      if (this.isLoading) return

      // 유효성 검사
      if (!validateDeliveryDetailAddress(this.delivery.detailAddress)) {
        document.getElementById('detail-address').focus()

        return
      }

      if (!validatePhoneNumber(this.delivery.phoneNumber) && !this.isSign) {
        document.getElementById('phone-number').focus()

        return
      }

      if (validateUserEmail(this.userEmail) !== true && !this.isSign) {
        document.getElementById('user-email').focus()
        return
      }

      if (
        (this.$store.getters['preOrder/selectedGiftCards'].length > 0 ||
          this.$store.getters['preOrder/paymentMethod'].availableCashReceipt) &&
        this.$store.getters['preOrder/recentCashReceipt'].issue &&
        this.$store.getters['preOrder/cashReceiptNumber'].length < 10 &&
        !!this.$store.getters['preOrder/cashReceiptNumber'].match(/^[0-9+]*$/)
      ) {
        document.getElementById('cash-receipt-input').focus()

        return
      }

      // if (
      //   this.$store.getters['preOrder/recentCashReceipt'].type === 'BUSINESS' &&
      //   this.$store.getters['preOrder/cashReceiptNumber'].length > 10
      // ) {
      //   document.getElementById('cash-receipt-input').focus()

      //   return
      // }

      this.isLoading = true

      // 본인 인증
      const certificationResultSet = await this.$store.dispatch('preOrder/loadUserCertification')
      if (certificationResultSet.failed) {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message: '주문 중 문제가 발생했습니다. 잠시 후 다시 시도해주세요.',
          onOK: async () => {
            this.$appManager.action(Action.CLOSE)
          }
        })

        this.isLoading = false
        return
      }

      if (this.certification.needs) {
        this.$store.dispatch('toast/open', {
          text: '서비스의 안전한 사용을 위해 본인인증을 먼저 진행해주세요.',
          delay: 1000
        })

        this.isLoading = false
        return
      }

      const codeName = this.$store.getters['preOrder/paymentMethod'].codeName
      const baeminMemberNo = this.$store.getters.baeminMemberNo
      if (codeName === 'BAEMINPAY_BANK' || codeName === 'BAEMINPAY_CARD') {
        const { result } = await API.get(`/baeminpay/v1/users/${baeminMemberNo}`)

        if (!!result && result.hasPassword) {
          // result.hasPassword가 true일 때 password 객체가 생성된다.
          if (result.password.isLock) {
            alert('5회 이상 비밀번호가 틀렸습니다. 본인 여부를 확인바랍니다.')
            const BAEMIN_PAY_IDENTITY = `${
              process.env.VUE_APP_DEEP_LINK_PROTOCOL
            }./webview?webview_url=${encodeURIComponent(
              `${process.env.VUE_APP_BAEMIN_INTERNAL_WEB}/baeminpay/id-verification?baeminMemberNumber=${baeminMemberNo}`
            )}&webview_type=no_navigation&back=close`
            window.location.href = BAEMIN_PAY_IDENTITY
            this.isLoading = false
            return
          }
        }

        if (!!result && !result.hasPassword) {
          this.$store.dispatch('modal/open', {
            type: 'PasswordReset',
            subMessage: '휴대폰 본인인증이 필요합니다',
            message: '',
            onOK: async () => {
              const BAEMIN_PAY_IDENTITY = `${
                process.env.VUE_APP_DEEP_LINK_PROTOCOL
              }./webview?webview_url=${encodeURIComponent(
                `${process.env.VUE_APP_BAEMIN_INTERNAL_WEB}/baeminpay/id-verification?baeminMemberNumber=${baeminMemberNo}`
              )}&webview_type=no_navigation&back=close`
              window.location.href = BAEMIN_PAY_IDENTITY

              this.$store.dispatch('modal/close')
            },
            onCancel: () => {
              this.$store.dispatch('modal/close')
            }
          })

          this.isLoading = false
          return
        }
      }

      // 주문 생성
      const { failed, message, result } = await this.$store.dispatch('preOrder/doPayment')
      if (failed) {
        this.$store.dispatch('modal/open', {
          type: 'Check',
          message,
          onOK: async () => {
            // FIXME error message 로 액션 분기하고 있음
            this.handlePaymentFailureByMessage(message)
          }
        })

        this.isLoading = false
        return
      }

      // 결제화면 전환
      const url = result.paymentRequestUrl
      const jsonParams = {
        func: 'goPage',
        arg: {
          page: 'pgcard',
          url: `${url}`
        }
      }

      this.doPaymentLog()

      const pgUrl = `smartbaedal://api?json=${encodeURIComponent(JSON.stringify(jsonParams))}`
      this.$appManager.moveSimple(pgUrl)

      const timeout = window.setTimeout(() => {
        this.isLoading = false
        window.clearTimeout(timeout)
      }, 1000)
    },

    redirectCertificationPage() {
      const { needs, url } = this.certification
      if (!needs) return

      this.$store.commit('preOrder/setCertification', { needs: false })
      this.$appManager.moveSimple(url)
    },

    handlePaymentFailureByMessage(message) {
      const moveToShopHomePatterns = [/지금은 운영시간이 아니에요/gim]
      const invalidGiftCardPatterns = [
        /상품권을 다시 선택해 주세요/gim,
        /사용 불가능한 상품권이 있습니다. 확인 후 다시 이용해주세요./gim
      ]

      if (moveToShopHomePatterns.some(pattern => pattern.test(message))) {
        this.$appManager.move(Location.SHOP, this.$store.getters.isAndroid, MoveType.REPLACE, {
          market_cartToolTip: false,
          market_shopNo: this.$store.getters.baeminShopNo
        })
        return
      }

      if (invalidGiftCardPatterns.some(pattern => pattern.test(message))) {
        //  모달 닫고, 선택한 상품권 reset하고 , 다시 api 호출하기
        this.$store.dispatch('modal/close')

        this.$store.commit('preOrder/resetGiftCards')
        this.$store.commit('preOrder/setSelectedGiftCards', [])
        this.$store.commit('preOrder/setBaeminPoint', { spentAmount: null, use: false })
        this.$store.commit('preOrder/setCoupon')
        this.$store.dispatch('preOrder/loadGiftCard')

        return
      }

      this.$appManager.action(Action.CLOSE)
    }
  }
}
</script>
